import {
  dehydrate,
  QueryClient,
  type DehydratedState,
} from '@tanstack/react-query'
import type {
  UserGetPortfolioChartInput,
  UserGetWalletPortfolioChartInput,
} from '../api'
import {
  getUserPortfolio,
  getUserPortfolioChart,
  getWalletPortfolioChart,
  getUserPerformance,
} from './user-portfolio.service'
import { EUserPortfolioQueryKey } from './user-portfolio.types'
import { Cookie } from '@repo/tools'

export const portfolioOptions = () => ({
  queryKey: [EUserPortfolioQueryKey.USER_PORTFOLIO],
  queryFn: getUserPortfolio,
  staleTime: 2,
  enabled: !!Cookie.get('access_token'),
})

export const userPortfolioChartOptions = (
  params: UserGetPortfolioChartInput,
) => ({
  queryKey: [EUserPortfolioQueryKey.USER_PORTFOLIO_TIME_SERIES, params],
  queryFn: () => getUserPortfolioChart(params),
  enabled: !!params.period,
})

export const prefetchUserPortfolio = async (): Promise<DehydratedState> => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(portfolioOptions())
  return dehydrate(queryClient)
}

export const prefetchUserPortfolioChart = async (
  params: UserGetPortfolioChartInput,
): Promise<DehydratedState> => {
  const queryClient = new QueryClient()
  await queryClient.prefetchQuery(userPortfolioChartOptions(params))
  return dehydrate(queryClient)
}
export const walletPortfolioChartOptions = (
  params: UserGetWalletPortfolioChartInput,
) => ({
  queryKey: [EUserPortfolioQueryKey.WALLET_PORTFOLIO_CHART, params],
  queryFn: () => getWalletPortfolioChart(params),
  enabled: !!params.orgCurrency && !!params.period,
})

export const userPerformanceOptions = () => ({
  queryKey: [EUserPortfolioQueryKey.USER_PERFORMANCE],
  queryFn: getUserPerformance,
  enabled: !!Cookie.get('access_token'),
})
